"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextElementMen = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TextElement = require("./TextElement");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TextElementMen = function TextElementMen(_ref) {
  var text = _ref.text,
    element = _ref.element,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$onKeyPress = _ref.onKeyPress,
    onKeyPress = _ref$onKeyPress === void 0 ? function () {} : _ref$onKeyPress,
    className = _ref.className,
    styles = _ref.styles,
    _ref$sanitize = _ref.sanitize,
    sanitize = _ref$sanitize === void 0 ? false : _ref$sanitize,
    children = _ref.children;
  if (children) {
    return /*#__PURE__*/_react["default"].createElement(_TextElement.TextElement, {
      className: "men ".concat(className),
      element: element,
      onClick: onClick,
      onKeyPress: onKeyPress,
      style: styles,
      sanitize: sanitize
    }, children);
  }
  return /*#__PURE__*/_react["default"].createElement(_TextElement.TextElement, {
    className: "men ".concat(className),
    text: text,
    element: element,
    onClick: onClick,
    onKeyPress: onKeyPress,
    style: styles,
    sanitize: sanitize
  });
};
exports.TextElementMen = TextElementMen;
TextElementMen.propTypes = {
  /**
   * text or html string or node
   */
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  /**
   * what element to render
   */
  element: _propTypes["default"].string,
  /**
   * Optional string of classes
   */
  className: _propTypes["default"].string,
  /**
   * Optional object of styles
   */
  styles: _propTypes["default"].object,
  /**
   * Optional onClick handler
   */
  onClick: _propTypes["default"].func,
  /**
   * Optional onKeyPress handler
   */
  onKeyPress: _propTypes["default"].func
};
TextElementMen.defaultProps = {
  element: "p"
};